var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfLeather24 = function SvgHalfLeather24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M7.087 18.843a5.785 5.785 0 0 0-1.86.157L4 16.861c4.479-4.766 0-8.562 0-8.562l1.228-2.492C9.555 6.278 9.51 2 9.51 2h4.098a4.93 4.93 0 0 0 .391 1.814",
    stroke: "currentColor",
    strokeWidth: 1.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.952 6c.56.093 1.13.11 1.694.047L20 8.514s-4.94 3.756 0 8.477l-1.354 2.117S14.002 17.884 11.682 22h-.04A6.054 6.054 0 0 0 10 20.096",
    stroke: "currentColor",
    strokeWidth: 1.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHalfLeather24;